
import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import JobsPage from './pages/JobsPage';
import JobDetailPage from './pages/JobDetailPage';
import LoginPage from './pages/LoginPage';
import { getJobPortalRoute, migrateLegacyHashRoute, navigateToJobs } from './utils/navigation';

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  mobile?: string;
  city?: string;
  country?: string;
  type?: string;
}

const App: React.FC = () => {
  const [route, setRoute] = useState(migrateLegacyHashRoute);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const savedUserJson = localStorage.getItem('careGuardianUser');
    if (savedUserJson) {
      try {
        const savedUser = JSON.parse(savedUserJson);
        setUser(savedUser);
      } catch (e) {
        localStorage.removeItem('careGuardianUser');
      }
    }
  }, []);

  useEffect(() => {
    const handleNavigation = () => setRoute(getJobPortalRoute());
    window.addEventListener('popstate', handleNavigation);
    return () => window.removeEventListener('popstate', handleNavigation);
  }, []);
  
  const handleLogin = (user: User) => {
    localStorage.setItem('careGuardianUser', JSON.stringify(user));
    setUser(user);
  };
  
  const handleLogout = () => {
    localStorage.removeItem('careGuardianUser');
    setUser(null);
    navigateToJobs(true);
  };

  if (!user) {
    return <LoginPage onLogin={handleLogin} />;
  }

  let page;
  if (route.page === 'job') {
    page = <JobDetailPage jobId={route.jobId} user={user} />;
  } else {
    page = <JobsPage user={user} />;
  }

  return (
    <div className="min-h-screen bg-[#F7F6FA] font-sans text-[#636363]">
      <Header user={user} onLogout={handleLogout} />
      <main className="mx-auto max-w-7xl px-4 py-5 sm:px-6 sm:py-7 lg:px-8">
        {page}
      </main>
    </div>
  );
};

export default App;
